import { Avatar, Badge, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, InputAdornment, MenuItem, Modal, OutlinedInput, Popover, Select, TextField, Tooltip, Typography } from "@mui/material";
import "./CustomTable.css";
import React, { useEffect, useRef, useState } from "react";
import styles from "./CustomTable.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getPathFromLocalStroage } from "../../utils";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import HistoryIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { toggleLoader } from "../../Store/loader/loaderReducer";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { styled } from '@mui/material/styles';
import SocialPosts from "./SocialPosts";
import TextArea from "./TextArea";
import { OrgNavigation } from "../../Utils/handleOrgNavigation";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FilterListIcon from '@mui/icons-material/FilterList';
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const tabs = {
  0: "Edit",
  1: "Edit",
  2: "Edit",
  3: "Edit",
  4: "Review",
  5: "Restore",
};
const tableHeader = [
  "Drafts",
  "Scheduled",
  "Published",
  "Failed",
  "Pending Review",
  "Trash",
];

const postOption = [{ name: 'View Post', icon: 'view-post.svg' }, { name: 'Revert to Draft', icon: 'revert.svg' }, { name: 'Duplicate draft', icon: 'duplicate.svg' }, { name: 'Send for review', icon: 'review.svg' }, { name: 'Share Post', icon: 'share.svg' }, { name: 'Move to trash', icon: 'trash.svg' }];
const isSocialCharLimit = { 4: 63027, 5: 2200, 6: 280, 8: 3000 };

const hideDateTabs = [2, 4, 5];
const draftHead = ["Title", "Keywords", "Scheduled_Time", "Content"];
const platform = 'No platform connected. Go to the Integration tab to connect your platform.'
const social_icon = { 4: 'NewPost/facebook.svg', 5: 'NewPost/instagram.svg', 6: 'NewPost/x-icon.svg', 8: 'NewPost/linkedin.svg' };
const selectColour = { 4: '#1877F2', 6: 'black', 5: '#F00276', 8: '#0077B5' }
const selectTextCount = { 4: 63027, 6: 280, 5: 2200, 8: 3000 }

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
}));

const redioBtn = [0, 1];
const Platform = ['Wix API', 'Centilio', 'Zoho', 'Facebook', 'Instagram', 'Twitter', 'WordPress API', '', 'Wix', 'WordPress'];

const CustomTable = ({ tabvalue, ids, selectClear, setSelectClear, draft, edit, search, searchValue, changeTabValue, usersDetails, nextPage, cursor, checked, currentPage, setCurrentPage, totalCount }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [drafts, setDrafts] = useState({
    Title: "",
    Keywords: "",
    Scheduled_Time: "",
    ConteScheduled_Timent: "",
    Org_Id: "",
    Id: "",
  });



  const org_info = useSelector((state) => state?.org_info?.value);
  const org_id = org_info?.default_organizations?.Id;
  const post_info = useSelector((state) => state.post_info?.value?.data);
  const loader = useSelector((state) => state?.loader?.isLoading);

  const [open, setOpen] = useState(false);
  const [fileId, setFileId] = useState([]);
  const [share, setShare] = useState(false);
  const [tags, setTags] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [posts, setPosts] = useState('');
  const [images, setImages] = useState('');
  const [slideOpen, setSlideOpen] = useState(false);
  const [formDetails, setFormDetails] = useState({});
  const [channelId, setChannelId] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);
  const [selectedPages, setSelectedPages] = useState([]);
  const [integrateSocialAccount, setIntegrateSocialAccount] = useState(true);
  const [loading, setLoading] = useState(false);
  const [postOptions, setPostOptions] = useState(postOption);
  const [textCount, setTextCount] = useState();
  const [imageInfo, setImageInfo] = useState();
  const [allImagesDatas, setAllImagesDatas] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [post_info_val, setPost_info_val] = useState();
  const [filterTime, setFilterTime] = useState({ start: "", end: "" });

  const DatePickerOpen = Boolean(anchorEl);
  const id = DatePickerOpen ? 'simple-popover' : undefined;



  const dispatch = useDispatch();
  const handleClose = () => setOpen(false);


  const location = useLocation();
  const navigate = useNavigate();
  const navPath = OrgNavigation();

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const scrollRef = useRef(null);
  const inputRef = useRef(null);
  const popupRef = useRef(null);




  let parts = location.pathname.split('/');
  const pathLocal = getPathFromLocalStroage();
  let editor = parts.slice(3).join('/');


  useEffect(() => {
    if (selectClear) {
      setSelectedItems([])
      setSelectClear(false)
    }
  }, [selectClear])

  useEffect(() => {
    if (formDetails?.socialImg === undefined) {
      setIntegrateSocialAccount(false)
    }
    else setIntegrateSocialAccount(true)
  }, [formDetails])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDatePickerClose = () => {
    setAnchorEl(null);
  };


  // useEffect(() => {
  //   if (checked && selectedItems?.length) setSelectedItems([]);
  // }, [checked, selectedItems]); very importent do not remove this code

  useEffect(() => {
    setPost_info_val(post_info)

  }, [post_info])


  const handleDraft = (item) => {
    let data = {
      title: item.Title,
      keywords: item.Keywords,
      scheduled_date: moment(item.Scheduled_Time, "DD/MM/YYYY hh:mm A").format("DD/MM/YYYY HH:mm"),
      content: item.Content,
      org_id: org_id,
      id: item.Id,
    };

    if (data.scheduled_date === 'Invalid date') {
      delete data.scheduled_date;
    }

    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_POST, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        dispatch(toggleLoader(false));
        navigate(`/c${org_id}${pathLocal.path}`);
        changeTabValue(0)
        usersDetails();
      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const handleFilter = (e) => {

    let val = dayjs(e.$d).format("DD-MMM-YYYY hh:mm");
    const original = moment(val, 'DD-MMM-YYYY HH:mm');
    
    const after12Hours = original.clone().add(12, 'hours');
    const timestampStart = moment(original, 'DD-MMM-YYYY HH:mm').valueOf();
    const timestampEnd = moment(after12Hours, 'DD-MMM-YYYY HH:mm').valueOf();

    setFilterTime({ ...filterTime, start: timestampStart, end: timestampEnd })
    usersDetails("", timestampStart, timestampEnd);

  };


  const handleSentForReview = (item) => {

    let data = {
      content: item.Content,
      org_id: org_id,
      post_id: item.Id,
    };

    // if (data.scheduled_date === 'Invalid date') {
    //   delete data.scheduled_date;
    // }

    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_SEND_FOR_REVIEW, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        dispatch(toggleLoader(false));
        navigate(`/c${org_id}${pathLocal.path}`);
        changeTabValue(4);
        usersDetails();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error?.details || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const handleView = (item) => {
    let data = {
      org_id: org_id,
      post_id: item.Id,
    };

    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_VIEWPOST, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        dispatch(toggleLoader(false));
      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const handleIntegrationChannel = (item) => {
    dispatch(toggleLoader(true));
    axios.get(process.env.REACT_APP_INTEGRATION_INFO, { withCredentials: process.env.REACT_APP_CREDENTIALS, params: { org_id: org_id } })
      .then((res) => {

        const filteredData = res?.data?.integration_information?.map(({ Channel_Id, Channel_Type }) => ({
          channelid: Channel_Id,
          channeltype: Channel_Type,
        }));

        handlePostDetails(item.Id);
        setChannelId(filteredData);

      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const handlePostDetails = (post_id) => {

    axios.get(process.env.REACT_APP_POST_LINK, { withCredentials: process.env.REACT_APP_CREDENTIALS, params: { org_id: org_id, post_id: post_id } })
      .then((res) => {
        if (res?.data?.socialImage === 'No Channels Connected') {
          toast.error(platform);
        } else {
          let data = { ...formDetails };
          data['socialImg'] = res?.data?.socialImage;
          setFormDetails(data);
          setSelectedPages(data.socialImg);
          setSelectedPage(data?.socialImg[0]);
          if (data?.socialImg?.length === 1) setSlideOpen(true);
          setShare(true);
          setPosts(res?.data?.link)
        }
        dispatch(toggleLoader(false));
      })
      .catch((err) => {
        const dynamicKey = err?.response?.data && Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const handleSharePost = (item, filteredData) => {
    let data = {
      org_id: org_id,
      post_id: item.Id,
      channel: filteredData
    };

    // axios.post(process.env.REACT_APP_SOCIAL_FEED, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
    //   .then((res) => {
    //     setShare(true);
    //     handlePostDetails(item.Id);
    //   })
    //   .catch((err) => {
    //     toast.error(err.message);
    //     dispatch(toggleLoader(false));
    //   });
  };

  useEffect(() => {
    const optionsToExcludeInOtherTabs = ['View Post', 'Revert to Draft', 'Share Post'];
    if (tabvalue !== 2) {
      const filteredOptions = postOptions?.filter(item =>
        !optionsToExcludeInOtherTabs.includes(item.name)
      );
      setPostOptions(filteredOptions);
    };

    if (!redioBtn.includes(tabvalue)) {
      setPostOptions(current =>
        current.filter(item => {
          return item.name !== 'Send for review';
        }),
      );
    };
  }, []);

  const handlePostHandler = (type, item) => {


    switch (type) {
      case 'View Post':
        org_info.blog_platform.length > 0 ? handlePostView(item) : toast.error(platform);
        break;
      case 'Revert to Draft':
        handleRevertToDraft(item);
        break;
      case 'Duplicate draft':
        handleDraft(item);
        break;
      case 'Send for review':
        handleSentForReview(item)
        break;
      case 'Share Post':
        org_info.blog_platform.length > 0 ? handleIntegrationChannel(item) : toast.error(platform);
        break;
      case 'Move to trash':
        ids([item], "Trash")
        break;
      default:
        break;
    }
  };

  const isSelected = (item) => {
    return selectedItems.includes(item);
  };

  const handleCheckboxChange = (item) => {

    setSelectedItems((prevSelectedItems) => {
      if (prevSelectedItems.includes(item)) {
        return prevSelectedItems.filter((i) => i !== item);
      } else {
        return [...prevSelectedItems, item];
      }
    });
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });

  useEffect(() => {
    if (post_info_val?.length > 0 && post_info_val?.length === selectedItems?.length) {
      setSelectAll(true);
    } else setSelectAll(false);
  }, [selectedItems]);

  useEffect(() => {
    setSelectedItems([]);
    setSelectAll(false);
  }, [tabvalue]);

  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else setSelectedItems(post_info_val);
  };

  const handleTime = (e) => {
    if (e) {
      let val = dayjs(e.$d).format("DD-MMM-YYYY hh:mm");
      setDrafts(cur => ({ ...cur, Scheduled_Time: val }));
    }
  };

  const handleSaveDraft = () => {
    draft(drafts);
    handleClose();
    setSelectedItems([]);
  };

  const handleReject = () => {
    ids([drafts]);
    handleClose();
  };

  const handleTableButton = (item) => {
    if (tabvalue === 5) {
      ids([item], "Restore");
    } else edit(item);
  };

  const handleSearch = (e) => {
    search(e.target.value);
  };

  const handleRevertToDraft = (item) => {
    const id = item ? [item] : selectedItems;
    ids(id, "Revert")
    setSelectedItems([]);
  };

  const handlePostView = (item) => {
    let data = {
      org_id: org_id,
      post_id: item.Id,
    };

    dispatch(toggleLoader(true));
    setLoading(true);
    axios
      .get(process.env.REACT_APP_VIEWPOST, {
        params: data,
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        const URL = res.data.data.url
        window.open(URL, '_blank');
        dispatch(toggleLoader(false));
        setLoading(false);
      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
        setLoading(false);
      });
  };



  const renderTabColumns = (item) => {
    switch (tabvalue) {
      case 0:
        return (
          <Box sx={{ display: "flex", gap: '5px' }}>
            <Box>{item.Created_Time}</Box>
            <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>
            <Box sx={{ textTransform: 'capitalize !important' }}>{item.Channel_Type === 2 ? item.App_Name : Platform[item.Channel_Type - 1]}</Box>
            {item.Scheduled_Time && <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>}
            {item.Scheduled_Time && <Box>Scheduled for {item.Scheduled_Time}</Box>}
          </Box>
        );
      case 1:
        return (
          <Box sx={{ display: "flex", gap: '5px' }}>
            <Box sx={{ textTransform: 'capitalize !important' }}>{item.Channel_Type === 2 ? item.App_Name : Platform[item.Channel_Type - 1]}</Box>
            {item.Scheduled_Time && <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>}
            {item.Scheduled_Time && <Box>Scheduled for {item.Scheduled_Time}</Box>}
          </Box>
        );
      case 2:
        return (
          <Box sx={{ display: "flex", gap: '5px' }}>
            <Box>{item.Scheduled_Time}</Box>
            <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>
            <Box sx={{ textTransform: 'capitalize !important' }}>{item.Channel_Type === 2 ? item.App_Name : Platform[item.Channel_Type - 1]}</Box>
          </Box>
        );
      case 3:
        return (
          <Box sx={{ display: "flex", gap: '5px' }}>
            <Box>{item.Modified_Time}</Box>
            <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>
            <Box sx={{ textTransform: 'capitalize !important' }}>{item.Channel_Type === 2 ? item.App_Name : Platform[item.Channel_Type - 1]}</Box>
            <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>
            <Box > <Tooltip title={item.Info}><Box maxWidth={'350px'} color={"red"} textOverflow={"ellipsis"} whiteSpace={"nowrap"} overflow={"hidden"}
            >{item.Info}</Box></Tooltip></Box>
          </Box>
        );
      case 4:
        return (
          <Box sx={{ display: "flex", gap: '5px' }}>
            <Box>{item.Created_Time}</Box>
            <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>
            <Box sx={{ textTransform: 'capitalize !important' }}>{item.Channel_Type === 2 ? item.App_Name : Platform[item.Channel_Type - 1]}</Box>
            {item.Scheduled_Time && <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>}
            {item.Scheduled_Time && <Box>Scheduled for {item.Scheduled_Time}</Box>}
          </Box>
        );
      case 5:
        return (
          <Box sx={{ display: "flex", gap: '5px' }}>
            <Box>{item.Created_Time}</Box>
            <Box sx={{ color: 'gray', padding: '2px', fontSize: '10px' }}>
              <FiberManualRecordIcon fontSize="none" /></Box>
            <Box sx={{ textTransform: 'capitalize !important' }}>{item.Channel_Type === 2 ? item.App_Name : Platform[item.Channel_Type - 1]}</Box>
          </Box>
        );
      default:
        return (
          <Box>
            <Box>{item.Created_Time}</Box>
            <Box sx={{ textTransform: 'capitalize !important' }}>{item.Channel_Type === 2 ? item.App_Name : Platform[item.Channel_Type - 1]}</Box>
          </Box>
        );
    }

  };

  const handleTags = (event) => {
    const tag = event.target.value;
    setTags(tag);
  };


  const handleEmojiClick = (emoji) => {
    setPosts((prev) => prev + emoji);
    // setShowPopup(false);
  };

  const handleBlur = () => {
    if (showPopup) setShowPopup(false);
  };

  const handlePost = () => {
    let findCharLimit = selectedPages?.find(page => posts?.length > isSocialCharLimit[page.channelType]);
    if (findCharLimit) {
      toast.error(`Character count can't exceed ${isSocialCharLimit[findCharLimit.channelType]} characters.`);
      return;
    }

    const result = selectedPages.map(({ file_id, ...obj }) => ({
      ...obj,
      file_ids: fileId,
      caption: posts
    }));

    let formDatas = {
      org_id: org_id,
      channel: result,
    };

    dispatch(toggleLoader(true));
    setLoading(true);
    axios.post(process.env.REACT_APP_SOCIAL_FEED, formDatas, { withCredentials: process.env.REACT_APP_CREDENTIALS })
      .then((res) => {
        setShare(false);
        setFormDetails({});
        setPosts('');
        setSelectedPage(null);
        setSelectedPages([]);
        setFileId([]);
        setSlideOpen(false);
        dispatch(toggleLoader(false));
        toast.success("Success");
        setLoading(false);
      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
        setLoading(false);
      })
  };

  const handleUpload = (e) => {
    let file = e.target.files[0];
    let form = {
      file: file,
      org_id: org_id,
    };

    // const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {

        const meta = {
          imagename: file.name,
          size: file.size,
          width: img.width,
          height: img.height,
        };



        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const maxSizeMB = 25;
        const maxSizeBytes = maxSizeMB * 1024 * 1024;

        if (fileId?.length >= 13) return;

        if (!allowedTypes.includes(file.type)) {
          toast.error('Invalid file format. Please upload a valid file in the appropriate format (e.g. .jpg, .jpeg, .png ).');
          return;
        }

        if (file.size > maxSizeBytes) {
          toast.error(`The file you are trying to upload is too large. The maximum file size allowed is ${maxSizeMB} MB.`);
          return;
        }

        let getFile_id;
        if (selectedPage) getFile_id = selectedPage;
        else getFile_id = selectedPages[0];

        const formData = new FormData();

        Object.keys(form).forEach((key) => {
          formData.append(key, form[key]);
        });

        dispatch(toggleLoader(true));
        axios.post(process.env.REACT_APP_SOCIAL_ATTACHMENT, formData, { withCredentials: process.env.REACT_APP_CREDENTIALS })
          .then((res) => {
            setFileId((prevFileIds) => [...prevFileIds, res.data.response.fileId]);
            let data = formDetails ? { ...formDetails } : {};
            let idx = data.socialImg?.findIndex(item => item.channelId === getFile_id?.channelId);
            data.socialImg[idx]['file_id'] = [...(data.socialImg[idx]['file_id'] || []), res?.data?.response?.fileId];
            data['total_file_id'] = [...(data['total_file_id'] || []), res?.data?.response?.fileId];
            data['image_data'] = [...(data['image_data'] || []), {
              name: meta.imagename,
              size: meta.size,
              width: meta.width,
              height: meta.height,
              file_id: res?.data?.response?.fileId
            }];

            setFormDetails(data);
            setSelectedPage((pre) => {
              const fileIdSet = new Set(pre.file_id || []);
              fileIdSet.add(res.data.response.fileId);
              return {
                ...pre,
                file_id: [...fileIdSet],
              };
            });

            setSelectedPages((prevData) => {
              const updatedPages = prevData.map((item) => {
                if (item.channelId === getFile_id?.channelId) {
                  const fileId = res?.data?.response?.fileId;

                  const fileIds = item.file_id || [];
                  if (!fileIds.includes(fileId)) {
                    const updatedFileIds = [...fileIds, fileId];
                    return { ...item, file_id: updatedFileIds };
                  } else {
                    return item;
                  }
                }
                return item;
              });
              return updatedPages;
            });
            dispatch(toggleLoader(false));
          })
          .catch((err) => {
            const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
            const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
            toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
            dispatch(toggleLoader(false));
          })
      };
      img.src = event.target.result;
    };

    reader.readAsDataURL(file);

  };

  const handleRemoveImage = (ids) => {
    const newFileid = fileId.filter(id => id !== ids);
    const removeFileId = selectedPage?.file_id?.filter(id => id !== ids);
    // 1. Remove from image_data
    formDetails.image_data = (formDetails?.image_data || [])
      .filter(item => item.file_id !== ids);

    // 2. Remove from socialImg
    if (Array.isArray(formDetails.socialImg)) {
      formDetails.socialImg = formDetails.socialImg
        .map(obj => {
          const newFileIds = Array.isArray(obj.file_id)
            ? obj.file_id.filter(id => id !== ids)
            : [];
          return { ...obj, file_id: newFileIds };
        })
        .filter(obj => obj.file_id.length > 0); // only keep if file_id not empty
    }

    // 3. Remove from total_file_id
    if (Array.isArray(formDetails.total_file_id)) {
      formDetails.total_file_id = formDetails.total_file_id.filter(
        id => id !== ids
      );
    }

    setSelectedPage(pre => ({ ...pre, file_id: removeFileId }));
    setFileId(newFileid);
  };

  const handleOpenSocial = (item, idx) => {
    let arr = [];
    setSelectedPages((prev) => {
      const updated = prev.some((i) => i.channelId === item.channelId)
        ? prev.filter((i) => i.channelId !== item.channelId)
        : [...prev, item];
      arr = updated;
      return updated;
    });

    if (arr?.length === 1) {
      setSelectedPage(arr[0]);
      setSlideOpen(!slideOpen);
    } else {
      if (!arr?.length) setSelectedPage(null);
      setSlideOpen(false);
    }


    let data = { ...formDetails };
    if (posts?.length) {
      data['type'] = item?.channelType;
      data['image'] = images;
      setFormDetails(data);
    }
  };

  const modalRef = useRef(null);

  const handleShareModalClose = () => {
    setShare(false);
  };

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (modalRef.current && !modalRef.current.contains(event.target)) {
  //       handleShareModalClose();
  //     }
  //   };
  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  const isUrl = (value) => {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  };

  return (
    <Box sx={{ padding: "2rem" }}>
      <Box className={styles.table_border_top}>
        <Box className={styles.table_border}>
          <Box>
            <FormGroup>
              <FormControlLabel
                className={styles.table_Select_box}
                control={
                  <Checkbox
                    checked={selectAll}
                    indeterminate={
                      selectedItems?.length !== 0 &&
                      selectedItems?.length !== post_info_val?.length
                    }
                    onChange={handleSelectAllChange}
                  />
                }
                label={
                  selectedItems?.length
                    ? `${selectedItems?.length} Selected`
                    : ""
                }
                disabled={!post_info_val?.length}
              />
            </FormGroup>
          </Box>
          <Box sx={{ display: "flex", gap: '5px' }}>
            <Box>
              <Button onClick={handleClick} variant="outlined" sx={{ textTransform: "none" }} startIcon={<FilterListIcon />}>
                Filter
              </Button>
            </Box>
            <Box className={styles.table_filter}>
              {selectedItems?.length ? (
                <Box className={styles.table_trash_btns}>
                  {tabvalue === 2 && (
                    <Box>
                      <Button
                        startIcon={<HistoryIcon fontSize="small" />}
                        onClick={() => handleRevertToDraft()}
                        variant="text"
                      >
                        Revert to Draft
                      </Button>
                    </Box>
                  )}
                  <Box>
                    <Button
                      className={styles.table_trash_btns_delete}
                      startIcon={<DeleteOutlineIcon fontSize="small" />}
                      variant="text"
                      onClick={() => { ids(selectedItems, tabvalue === 5 ? "Delete" : "Trash") }
                      }
                    >
                      {tabvalue === 5 ? "Delete" : "Move to Trash"}
                    </Button>
                  </Box>
                </Box>
              ) : (
                <Box>
                  <TextField
                    className="input_area_mui"
                    ref={inputRef}
                    sx={{
                      borderRadius: '30px',
                      height: '2rem',
                    }}
                    onChange={handleSearch}
                    placeholder="Search..."
                    value={searchValue}
                    id="myInput"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
        {(loader && cursor === 1) ? (
          <div className={`${styles.table_body_data} ${styles.table_body_error_head}`} >
            <Box>
              <Box className={styles.table_body_error}>

              </Box>
            </Box>
          </div>
        ) : post_info_val?.length ? (
          <Box className={styles.table_body_data}>
            {post_info_val?.map((item, idx) => (
              <Box
                className={`${styles.table_user_title} ${isSelected(item) && styles.table_user_left_border
                  }`}
                key={idx}
              >
                <Box className={styles.table_user_title_border}>
                  <Box sx={{ width: '100%' }} className={styles.table_user_details}>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isSelected(item)}
                            onChange={() => handleCheckboxChange(item)}
                          />
                        }
                      />
                    </Box>
                    <Box className={styles.user_wrap}>
                      {item?.File_Id ?
                        isUrl(item?.File_Id) ? <img src={item?.File_Id} className={styles.user_image} alt="featured" /> :
                          <img src={`${process.env.REACT_APP_ATTACHMENT}?file_id=${item?.File_Id}`} className={styles.user_image} alt='featured' /> :
                        <img alt="user_img" src={process.env.REACT_APP_IMAGE_URL + "PostSvg/user_img.svg"} className={styles.user_img_empty} />}
                    </Box>
                    <Box sx={{ width: '100%' }}>
                      <Box className={styles.table_title_name}>
                        <Tooltip title={item.Title}> {item.Title}</Tooltip>
                      </Box>
                      <Box sx={{ display: 'flex' }}>
                        <Box className={styles.table_title_phara}>
                          {renderTabColumns(item)}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.table_btn_div}>
                    {item.Post_Processing_Status === 1 && <Box><CircularProgress size="1.4rem" /></Box>}
                    {tabvalue === 5 ? <Button
                      variant="contained"
                      className={styles.table_btn_edit}
                      disabled={item.Post_Processing_Status === 1}
                      onClick={() => handleTableButton(item)}
                    >
                      {tabs[tabvalue] ?? "Edit"}
                    </Button> :
                      <Box className={styles.editor_body}>
                        <Button
                          component={Link}
                          className={styles.edit_button}
                          variant="outlined"
                          to={`/c${org_id}/post/${editor}/${item.Id}`}
                          disabled={item.Post_Processing_Status === 1}
                          startIcon={<img alt="editor_img" src={process.env.REACT_APP_IMAGE_URL + "PostSvg/pencil.svg"} className={styles.editor_icon} />}
                        >
                          {tabs[tabvalue] ?? "Edit"}
                        </Button>
                        <Select
                          value={""}
                          className={styles.editor_select}
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none !important",
                            },
                          }}
                          MenuProps={{
                            classes: {
                              paper: "editor_page_select",
                              border: "none",
                              color: "#fff !important",
                            },
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "right",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "right",
                            },
                          }}
                        >
                          {postOptions?.map((s, i) => (
                            <MenuItem
                              className={styles.editor_select_wrapper}
                              key={i}
                              value={s.name}
                              onClick={() => handlePostHandler(s.name, item)}
                            >
                              <Box className={styles.editor_select_text_container}>
                                <img alt="post_option_img" src={process.env.REACT_APP_IMAGE_URL + `PostSvg/${s.icon}`} className={styles.editor_option_icon} />
                                <Box sx={{ color: s.name === 'Move to trash' ? 'var(--danger) !important' : 'var(--table-font-color)' }}>{s.name}</Box>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    }

                    <Box>
                    </Box>

                    {item.Post_Processing_Status !== 1 && tabvalue === 5 && <Box className={styles.table_user_more_icon}>
                      <DeleteOutlineIcon
                        onClick={() => ids([item], "Delete")}
                        className={styles.table_user_delete_btn}
                        sx={{
                          border: "1px solid rgba(231, 234, 243, 0.70)",
                          borderRadius: "50%",
                          fill: "#377DFF",
                        }}
                      />
                    </Box>}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Box
            className={`${styles.table_body_data} ${styles.table_body_error_head}`}
          >
            <Box>
              <Box className={styles.table_body_error}>
                <img
                  alt="user_img"
                  style={{ width: "10%" }}
                  src={
                    process.env.REACT_APP_IMAGE_URL + "ErrorImg/errorimg.png"
                  }
                />
              </Box>
            </Box>
            <Box className={styles.table_body_error_text}>
              No {tableHeader[tabvalue]} Posts
            </Box>
          </Box>
        )}
      </Box>

      {/* Pagination */}
      {post_info_val?.length > 0 && (
        <Box className={styles.pagination_container}>
          <Box className={styles.pagination_info}>
            <Typography className={styles.pagination_text}>
              Showing <span className={styles.pagination_highlight}>{((currentPage - 1) * 10) + 1}</span> to{' '}
              <span className={styles.pagination_highlight}>
                {((currentPage - 1) * 10) + post_info_val.length}
              </span>
              {totalCount > 0 && (
                <> of <span className={styles.pagination_highlight}>{totalCount}</span> results</>
              )}
            </Typography>
          </Box>

          {/* Always show pagination controls when there are posts */}
          <Box className={styles.pagination_controls}>
            {/* First Page Button */}
            <Button
              className={styles.pagination_btn}
              onClick={() => {
                if (!loader) {
                  setCurrentPage(1);
                  usersDetails('page', filterTime.start, filterTime.end, 1);
                }
              }}
              disabled={currentPage === 1 || loader}
            >
              <svg className={styles.pagination_icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M11 19l-7-7 7-7M18 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              </svg>
            </Button>

            {/* Previous Button */}
            <Button
              className={styles.pagination_btn}
              onClick={() => {
                if (!loader) {
                  setCurrentPage(currentPage - 1);
                  usersDetails('page', filterTime.start, filterTime.end, currentPage - 1);
                }
              }}
              disabled={currentPage === 1 || loader}
            >
              <svg className={styles.pagination_icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              </svg>
            </Button>

            {/* Page Numbers */}
            {(() => {
              // Calculate total pages using totalCount (from countingposts API)
              // Each page has 10 posts
              let totalPages;
              if (totalCount > 0) {
                totalPages = Math.ceil(totalCount / 10);
              } else if (post_info_val?.length > 0 && nextPage) {
                // If we have posts but no count yet, assume at least 5+ pages to show proper pagination
                // This will be corrected once the count API returns
                totalPages = Math.max(10, currentPage + 5);
              } else if (post_info_val?.length > 0) {
                // No more pages
                totalPages = currentPage;
              } else {
                totalPages = 1;
              }

              const pages = [];

              if (totalPages <= 5) {
                // Show all pages if 5 or fewer
                for (let i = 1; i <= totalPages; i++) {
                  pages.push(
                    <Button
                      key={i}
                      className={`${styles.pagination_page_btn} ${currentPage === i ? styles.pagination_page_active : ''}`}
                      onClick={() => {
                        if (!loader) {
                          setCurrentPage(i);
                          usersDetails('page', filterTime.start, filterTime.end, i);
                        }
                      }}
                      disabled={loader}
                    >
                      {i}
                    </Button>
                  );
                }
              } else {
                // More than 5 pages - show smart pagination
                // If current page is in first 3 pages, show: 1 2 3 ... [last-1] [last]
                // If current page is in last 3 pages, show: 1 ... [last-2] [last-1] [last]
                // Otherwise show: 1 ... [current-1] [current] [current+1] ... [last]

                if (currentPage <= 3) {
                  // Near the start: show first 3 pages
                  for (let i = 1; i <= 3; i++) {
                    pages.push(
                      <Button
                        key={i}
                        className={`${styles.pagination_page_btn} ${currentPage === i ? styles.pagination_page_active : ''}`}
                        onClick={() => {
                          if (!loader) {
                            setCurrentPage(i);
                            usersDetails('page', filterTime.start, filterTime.end, i);
                          }
                        }}
                        disabled={loader}
                      >
                        {i}
                      </Button>
                    );
                  }

                  // Ellipsis
                  pages.push(
                    <span key="ellipsis" className={styles.pagination_ellipsis}>
                      ...
                    </span>
                  );

                  // Last 2 pages
                  for (let i = totalPages - 1; i <= totalPages; i++) {
                    pages.push(
                      <Button
                        key={i}
                        className={`${styles.pagination_page_btn} ${currentPage === i ? styles.pagination_page_active : ''}`}
                        onClick={() => {
                          if (!loader) {
                            setCurrentPage(i);
                            usersDetails('page', filterTime.start, filterTime.end, i);
                          }
                        }}
                        disabled={loader}
                      >
                        {i}
                      </Button>
                    );
                  }
                } else if (currentPage >= totalPages - 2) {
                  // Near the end: show first page
                  pages.push(
                    <Button
                      key={1}
                      className={`${styles.pagination_page_btn} ${currentPage === 1 ? styles.pagination_page_active : ''}`}
                      onClick={() => {
                        if (!loader) {
                          setCurrentPage(1);
                          usersDetails('page', filterTime.start, filterTime.end, 1);
                        }
                      }}
                      disabled={loader}
                    >
                      1
                    </Button>
                  );

                  // Ellipsis
                  pages.push(
                    <span key="ellipsis" className={styles.pagination_ellipsis}>
                      ...
                    </span>
                  );

                  // Last 3 pages
                  for (let i = totalPages - 2; i <= totalPages; i++) {
                    pages.push(
                      <Button
                        key={i}
                        className={`${styles.pagination_page_btn} ${currentPage === i ? styles.pagination_page_active : ''}`}
                        onClick={() => {
                          if (!loader) {
                            setCurrentPage(i);
                            usersDetails('page', filterTime.start, filterTime.end, i);
                          }
                        }}
                        disabled={loader}
                      >
                        {i}
                      </Button>
                    );
                  }
                } else {
                  // In the middle: show first page ... current-1 current current+1 ... last page
                  pages.push(
                    <Button
                      key={1}
                      className={`${styles.pagination_page_btn} ${currentPage === 1 ? styles.pagination_page_active : ''}`}
                      onClick={() => {
                        if (!loader) {
                          setCurrentPage(1);
                          usersDetails('page', filterTime.start, filterTime.end, 1);
                        }
                      }}
                      disabled={loader}
                    >
                      1
                    </Button>
                  );

                  // Ellipsis before
                  pages.push(
                    <span key="ellipsis1" className={styles.pagination_ellipsis}>
                      ...
                    </span>
                  );

                  // Current page and neighbors
                  for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pages.push(
                      <Button
                        key={i}
                        className={`${styles.pagination_page_btn} ${currentPage === i ? styles.pagination_page_active : ''}`}
                        onClick={() => {
                          if (!loader) {
                            setCurrentPage(i);
                            usersDetails('page', filterTime.start, filterTime.end, i);
                          }
                        }}
                        disabled={loader}
                      >
                        {i}
                      </Button>
                    );
                  }

                  // Ellipsis after
                  pages.push(
                    <span key="ellipsis2" className={styles.pagination_ellipsis}>
                      ...
                    </span>
                  );

                  // Last page
                  pages.push(
                    <Button
                      key={totalPages}
                      className={`${styles.pagination_page_btn} ${currentPage === totalPages ? styles.pagination_page_active : ''}`}
                      onClick={() => {
                        if (!loader) {
                          setCurrentPage(totalPages);
                          usersDetails('page', filterTime.start, filterTime.end, totalPages);
                        }
                      }}
                      disabled={loader}
                    >
                      {totalPages}
                    </Button>
                  );
                }
              }

              return pages;
            })()}

            {/* Next Button */}
            <Button
              className={styles.pagination_btn}
              onClick={() => {
                if (!loader) {
                  setCurrentPage(currentPage + 1);
                  usersDetails('page', filterTime.start, filterTime.end, currentPage + 1);
                }
              }}
              disabled={!nextPage || loader}
            >
              <svg className={styles.pagination_icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              </svg>
            </Button>

            {/* Last Page Button */}
            <Button
              className={styles.pagination_btn}
              onClick={() => {
                if (!loader && totalCount > 0) {
                  const lastPage = Math.ceil(totalCount / 10);
                  setCurrentPage(lastPage);
                  usersDetails('page', filterTime.start, filterTime.end, lastPage);
                }
              }}
              disabled={!nextPage || loader}
            >
              <svg className={styles.pagination_icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M13 5l7 7-7 7M6 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              </svg>
            </Button>
          </Box>
        </Box>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {draftHead?.map((item) => (
            <Box key={item} className={styles.modal_popup}>

              <Box className={styles.modal_popup_title}>{item}</Box>
              <FormControl size="small" fullWidth>
                {item !== "Scheduled_Time" ? (
                  <OutlinedInput
                    fullWidth
                    value={
                      drafts && item === "Scheduled_Time"
                        ? dayjs(moment(new Date(drafts[item])))
                        : drafts[item]
                    }
                    onChange={(e) =>
                      setDrafts(cur => ({ ...cur, [item]: e.target.value }))
                    }
                    className={styles.modal_popup_input}
                    placeholder={`Enter ${item} `}
                  />
                ) : (
                  // <LocalizationProvider dateAdapter={AdapterDayjs} slotProps={{ textField: { fullWidth: true } }}>
                  //     <DemoContainer
                  //         components={['DateTimePicker']}
                  //         sx={{
                  //             fieldset: { border: "1px solid #E6E7E9" },
                  //             '& .MuiOutlinedInput-root': {
                  //                 '&:hover fieldset': {
                  //                     borderColor: 'var(--primary) !important',
                  //                 },
                  //                 '& fieldset.MuiOutlinedInput-notchedOutline': {
                  //                     border: "1px solid #E6E7E9"
                  //                 },
                  //                 fontSize: '14px',
                  //                 paddingLeft: '2px',
                  //                 height: '41.92px'
                  //             },
                  //             paddingTop: '0px !important'
                  //         }}
                  //     >
                  //         <DemoItem>
                  //             <DateTimePicker
                  //                 format='DD-MMM-YYYY h:mm'
                  //                 value={dayjs(moment(new Date(drafts[item])))}
                  //                 viewRenderers={{ hours: renderTimeViewClock, minutes: renderTimeViewClock, seconds: renderTimeViewClock }}
                  //                 minDate={dayjs(new Date())}
                  //                 onChange={handleTime}
                  //                 sx={{ width: "100% !important", overflow: "hidden !important" }}
                  //             />
                  //         </DemoItem>
                  //     </DemoContainer>
                  // </LocalizationProvider>
                  <Box>
                    <Box className={styles.date_picker_wrap}>
                      <DatePicker
                        disabled={edit && tabvalue === 4}
                        selected={
                          drafts?.Scheduled_Time === "Invalid Date"
                            ? ""
                            : drafts?.Scheduled_Time
                        }
                        className={styles.date_picker}
                        onChange={handleTime}
                        minDate={new Date()}
                        timeInputLabel="Time:"
                        dateFormat="d-MMMM-yyy h:mm aa"
                        showTimeInput
                        wrapperClassName={styles.date_pickerr}
                        error={true}
                      />
                      <Box className={styles.clear_icon_wrap}>
                        {drafts?.Scheduled_Time && (
                          <CloseIcon
                            onClick={() =>
                              edit && tabvalue === 4
                                ? {}
                                : setDrafts({ ...drafts, Scheduled_Time: "" })
                            }
                            fontSize="small"
                            sx={{
                              display:
                                drafts?.Scheduled_Time === "Invalid Date" &&
                                "none",
                              "&:hover": {
                                color: "#ed4c78",
                                cursor:
                                  edit && tabvalue === 4
                                    ? "default"
                                    : "pointer",
                              },
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  </Box>
                )}
              </FormControl>
            </Box>
          ))}
          <Box
            className={styles.modal_popup_draft_btn}
            sx={{
              textAlign: "end",
              padding: "20px",
            }}
          >
            {tabvalue === 4 && (
              <Button
                variant="outlined"
                sx={{ colors: "red" }}
                onClick={() => handleReject()}
              >
                Reject
              </Button>
            )}
            <Button variant="contained" onClick={() => handleSaveDraft()}>
              Save as Draft
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={share}
        onClose={() => setShare(false)}
        sx={{ "& .MuiBackdrop-root": { backgroundColor: "#13214440" } }}
        closeAfterTransition
      >
        <Box style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, }}>
          <Box style={{ height: 'calc(-112px + 100vh)', padding: '0px 32px', display: 'flex', justifyContent: 'center', marginTop: '2%' }}>
            <Box style={{ height: '560px', width: 'fit-content', position: 'relative', zIndex: '0' }} ref={modalRef}>
              <Box className={styles.file_wrap} style={{ marginRight: slideOpen && '384px', width: '720px' }} >
                <Box className={styles.title_wrap}>
                  <Box className={styles.title_text}>Create Post</Box>
                  <Box className={styles.title_text} onClick={() => [setShare(false), setSelectedPage(null), setFileId([]), setSlideOpen(false)]}><CloseIcon className={styles.close_popups} sx={{ cursor: 'pointer' }} /></Box>

                  {/* <Select
                    value={tags}
                    onChange={handleTags}
                    className={styles.tags_btn}
                    sx={{ '& .MuiOutlinedInput-notchedOutline': { border: '.0625rem solid rgba(231,234,243,.7) !important' }, color: 'var(--table-header-font)', fontFamily: 'var(--primary-font-family) !important', '.MuiMenuItem-root': { height: '160px !important' } }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          '& .MuiMenuItem-root.Mui-selected': {
                            backgroundColor: 'rgba(189,197,209,.3)',
                            borderRadius: '5px',
                            color: 'var(--table-font-color) !important'
                          },
                        },
                      },
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return <Box className={styles.tags_menu_item}>Add tags</Box>;
                      }
                      return selected;
                    }}
                  >
                    {tagsOptions.map((option) => (
                      <MenuItem
                        sx={{
                          color: 'var(--table-header-font) !important',
                          marginTop: '1px !important',
                          justifyContent: 'center',
                          display: 'flex',
                          "&:hover": {
                            backgroundColor: "rgba(189,197,209,.3)",
                            borderRadius: '5px'
                          }
                        }}
                        key={option.value} className={styles.tags_menu_item} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select> */}  {/* importent do not remove this */}
                </Box>

                {formDetails?.socialImg !== 'No Channels Connected' && formDetails?.socialImg !== undefined ?
                  <Box className={styles.socialImg_icon_wrap}>
                  {formDetails?.socialImg?.map((item, i) => {
                      const selectedAccount = selectedPages.some(page => page.channelId === item.channelId);
                      const Name = item?.profileName?.slice(0, 1);
                      const selectedUser = selectedPages.find(page => page.channelId === item.channelId);
                      return (
                        <Box key={i} sx={{ filter: !selectedAccount && "grayscale(1)" }}>

                          <Badge
                            onClick={() => {
                              if (selectedPages.length > 1 || !selectedAccount) {
                                handleOpenSocial(item);
                              }
                            }}
                            overlap="circular"
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            className={selectedAccount && posts?.length >= isSocialCharLimit[selectedUser?.channelType] && styles.pulse_animation}
                            sx={{
                              border:
                                selectedAccount
                                  ? posts?.length >= isSocialCharLimit[selectedUser?.channelType]
                                    ? '2px solid red'
                                    : `2px solid ${selectColour[item.channelType]}`
                                  : '2px solid #ffff',
                              borderRadius: '50%',
                              padding: '2px',
                            }}
                            badgeContent={
                              selectedAccount && posts?.length >= isSocialCharLimit[selectedUser?.channelType] ? (
                                <Box
                                  sx={{
                                    backgroundColor: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: posts?.length > 10000 ? 28 : 20,
                                    height: posts?.length > 10000 ? 28 : 20,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '8px',
                                    fontWeight: 'bold',
                                    boxShadow: '0 0 0 2px white',
                                  }}
                                >
                                  {isSocialCharLimit[selectedUser?.channelType] - posts?.length}
                                </Box>
                              ) : null
                            }
                          >
                            <Badge
                              overlap="circular"
                              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                              badgeContent={
                                <SmallAvatar
                                  sx={{
                                    border:
                                      item.channelType === 5
                                        ? `2px solid ${selectColour[item.channelType]}`
                                        : `5px solid ${selectColour[item.channelType]}`,
                                    backgroundColor: `${selectColour[item.channelType]}`,
                                    cursor: 'pointer',
                                  }}
                                  alt="social_icon"
                                  src={process.env.REACT_APP_IMAGE_URL + social_icon[item?.channelType]}
                                />
                              }
                            >
                              {item?.profileUrl ? (
                                <Avatar
                                  alt="social_icon"
                                  src={item?.profileUrl}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : item?.profileName ? (
                                <Avatar
                                  sx={{
                                    bgcolor: `${selectColour[item.channelType]}`,
                                    cursor: 'pointer',
                                  }}
                                  alt="Remy Sharp"
                                  src="/broken-image.jpg"
                                >
                                  {Name}
                                </Avatar>
                              ) : (
                                <Avatar
                                  sx={{
                                    bgcolor: `${selectColour[item.channelType]}`,
                                    cursor: 'pointer',
                                  }}
                                  alt="Remy Sharp"
                                  src="/broken-image.jpg"
                                >
                                  C
                                </Avatar>
                              )}
                            </Badge>
                          </Badge>

                        </Box>
                      )
                    }
                    )
                    }
                  </Box> : <Box sx={{ padding: '10px 0px', color: "#377DFF", cursor: 'pointer', fontSize: '14px' }}>
                    <span onClick={() => navPath('/Integration')}>Connect Your Channels</span>
                    <span>
                      <Tooltip placement="top" title="No platform connected">
                        <ErrorOutlineIcon sx={{ margin: '5px', fontSize: '0.8rem', color: 'rgba(0, 0, 0, 0.54)' }} />
                      </Tooltip>

                    </span></Box>}

                <TextArea formDetails={formDetails} selectedPage={selectedPage} selectedPages={selectedPages} posts={posts} setPosts={setPosts} fileId={fileId} handleUpload={handleUpload} handleRemoveImage={handleRemoveImage} handleEmojiClick={handleEmojiClick} handleBlur={handleBlur} loading={loading} setTextCount={setTextCount} handlePost={handlePost} integrateSocialAccount={integrateSocialAccount} />
                {/* <Button variant="contained" className={styles.post_btn} onClick={handlePost}>Post</Button> */}
                {Object.keys(formDetails)?.map((item) => {
                  <Box sx={{ display: 'flex' }}>
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + item?.image}
                      className={styles.selected_icon_img}
                      alt="social_icon"
                    />
                    {/* <Box className={styles.text_field}>
                      <TextField
                        variant="outlined"
                        // onClick={}
                        sx={{
                          flex: 1,
                          "& .MuiOutlinedInput-root": {
                            "& fieldset.MuiOutlinedInput-notchedOutline": {
                              border: "none"
                            },
                            fontSize: "14px",
                            paddingLeft: "10px",
                          },
                        }}
                        placeholder="Start writing"
                        fullWidth
                      />
                    </Box> */}
                  </Box>
                })}

              </Box>

              <Box
                className={styles.popup_social}
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  width: 364,
                  backgroundColor: '#fff',
                  padding: '25px',
                  zIndex: -1,
                  borderRadius: '4px',
                  transition: '250ms ease-in-out',
                  translate: slideOpen ? '0px' : '-97%',
                }}
                onClick={() => setShare(share)}
              >
                <SocialPosts posts={posts} seleceted={selectedPage} />
              </Box>
            </Box>

          </Box>
        </Box>
      </Modal>
      <Popover
        id={id}
        open={DatePickerOpen}
        anchorEl={anchorEl}
        onClose={() => handleDatePickerClose()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Typography sx={{ p: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateTimePicker']}>
              <DateTimePicker format='DD-MMM-YYYY h:mm' label="Filter"
                onAccept={(e) => handleFilter(e)}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Typography>
      </Popover>
    </Box >
  );
};

export default CustomTable;